<template>
  <div class="msg-reply-rule page-box">
    <query-header
      :selected="selected"
      ref="header"
      @toQuery="toQuery"
      @add="addHandle"
      @delete="deleteHandle"
    ></query-header>
    <div class="page-content">
      <div class="vs-table-outer">
        <vs-table
          :data="listData"
        >
          <template
            slot="thead">
            <vs-th>
              规则名称
            </vs-th>
            <vs-th>
              匹配关键词
            </vs-th>
            <vs-th>
              消息类型
            </vs-th>
            <vs-th>
              回复内容
            </vs-th>
            <vs-th>
              操作
            </vs-th>
          </template>
          <template slot-scope="{data}">
            <vs-tr
              v-for="(tr, index) in data"
              :key="index"
              :data="tr"
            >
              <template class="expand-user" slot="expand">
                <div class="inner-item">
                  <div class="item">
                    <span class="label">作用范围</span>
                    <span>{{ tr.appid?'当前公众号':'全部公众号' }}</span>
                  </div>
                  <div class="item">
                    <span class="label">是否有效</span>
                    <span>{{ tr.status?'是':'否' }}</span>
                  </div>
                  <div class="item">
                    <span class="label">生效时间</span>
                    <span>{{ tr.effectTimeStart }}</span>
                  </div>
                </div>
                <div class="inner-item">
                  <div class="item">
                    <span class="label">精确匹配</span>
                    <span>{{ tr.exactMatch?'是':'否' }}</span>
                  </div>
                  <div class="item">
                    <span class="label">备注说明</span>
                    <span>{{ tr.desc || '无'}}</span>
                  </div>
                  <div class="item">
                    <span class="label">失效时间</span>
                    <span>{{ tr.effectTimeEnd }}</span>
                  </div>
                </div>
              </template>
              <vs-td :data="tr.ruleName">
                {{tr.ruleName}}
              </vs-td>
              <vs-td :data="tr.matchValue">
                {{tr.matchValue}}
              </vs-td>
              <vs-td :data="tr.replyType">
                {{tr.replyType}}
              </vs-td>
              <vs-td
              style="max-width: 800px"
              :data="tr.replyContent"
              >
                <div class="rap-normal">{{tr.replyContent}}</div>
              </vs-td>
              <vs-td>

                <el-button
                  v-if="isAuth('wx:msgreplyrule:update')"
                  type="text"
                  class="theme-color"
                  @click.stop="editHandle(tr)"
                >修改</el-button>

                <el-button
                  v-if="isAuth('wx:msgreplyrule:delete')"
                  type="text"
                  class="delete-btn"
                  @click.stop="deleteHandle(tr.ruleId)"
                >删除</el-button>
              </vs-td>

            </vs-tr>
          </template>
        </vs-table>
      </div>
      <div class="pagination-outer" v-if="total">
        <div class="paginnation-left">
          <size-change
            @sizeChange="sizeChange"
          ></size-change>
          <span
            class="tatol-count"
          >合计 {{total}} 条</span>
        </div>
        <vs-pagination
          class="pagination-box"
          :max="max"
          :total="pageSize"
          v-model="page"
        ></vs-pagination>
      </div>
    </div>
    <add-msg-reply-dialog
      :dialog-show="addDialogShow"
      @close="closeAddDialog"
      @add-success="addUserSuccess"
    ></add-msg-reply-dialog>
    <edit-msg-reply-dialog
      :form-data="formData"
      :dialog-show="editDialogShow"
      @close="closeEditDialog"
      @edit-success="editUserSuccess"
    ></edit-msg-reply-dialog>
    <multiple-delete-dialog
      ref="muldelete"
      :ids="ids"
      @sure-delete="confirmDelete"
    ></multiple-delete-dialog>
  </div>
</template>

<script>

import multipleDeleteDialog from "@/components/public/multipleDeleteDialog";
import addMsgReplyDialog from '@/components/wx/msg-reply-rule/addMsgReplyDialog'
import editMsgReplyDialog from "@/components/wx/msg-reply-rule/editMsgReplyDialog";
import queryHeader from "@/components/wx/msg-reply-rule/queryHeader";
import { mapGetters } from 'vuex'
import { colorRgba,parseTime } from '@/utils'
import initData from "@/mixins/initData";
import {deleteMsgReply} from "@/api/wx/msgReply";
export default {
  name: "index",
  components: {
    addMsgReplyDialog,
    editMsgReplyDialog,
    queryHeader,
    multipleDeleteDialog,
  },
  data() {
    return {
      name: '',
      selected: [],
      red: '#D85E5F',
      green: '#41B883',
      addDialogShow: false,
      editDialogShow: false,
      formData: {},
      ids: [],
    }
  },
  mixins: [initData],
  computed: {
    ...mapGetters(['themeColor','userInfo','selectedAppid']),
  },
  watch: {
    selectedAppid(newValue, oldValue) {
      if(newValue){
        this.searchHandle();
      }
    }
  },
  mounted(){
    this.searchHandle();
  },
  methods: {
    parseTime,
    beforeInit(){
      this.url = '/wx/manage/msgReplyRule/list';
      let header = this.$refs.header;

      this.params = {
        page: this.page,
        limit: this.size,
        matchValue: header.keywords
      }

      return true;
    },
    addHandle(){
      setTimeout(()=> {
        this.addDialogShow = true;
      },200);
    },
    addUserSuccess(){
      this.addDialogShow = false;
      this.searchHandle();
    },
    editHandle(row){
      setTimeout(()=> {
        this.editDialogShow = true;
        this.formData = row;
      },200);
    },
    editUserSuccess(){
      this.editDialogShow = false;
      setTimeout(()=> {
        this.searchHandle();
      },200);
    },
    closeEditDialog(){
      this.editDialogShow = false;
    },
    deleteHandle(id){
      this.$refs.muldelete.dialogShow = true;
      this.ids = id ? [id] : this.selected.map(item => item.ruleId);
      this.$refs.muldelete.dialogShow = true;
    },
    confirmDelete(ids){
      deleteMsgReply(ids).then((res) => {
        this.$refs.muldelete.loading = false;
        this.$refs.muldelete.dialogShow = false;
        this.$message({
          type: 'success',
          message: '已删除'
        });
        this.searchHandle();
      })
    },
    closeAddDialog(){
      this.addDialogShow = false;
    },
    getStatus(tr){
      if(tr.status === 0){
        return '禁用';
      }else {
        return '正常';
      }
    },
    getStyle(tr){
      if(tr.status === 0){
        return {
          backgroundColor: colorRgba(this.red ,0.1),
          color: this.red,
        };
      }else {

        return {
          backgroundColor: colorRgba(this.green,0.1),
          color: this.green,
        };
      }
    },
    searchHandle(){
      this.page = 1;
      this.init();
    },
  },
}
</script>

<style lang="scss" scoped>
.msg-reply-rule {
  .query-header{
    .el-col-el{
      margin-bottom: 0px;
    }
  }
  .box-item {
    margin-bottom: 10px;
  }
  .btn {
    margin-right: 10px;
  }
  .vs-table-outer {
    .vs-con-table {
      min-width: 1200px;
    }
  }
  .tag-box {
    padding: 5px 10px;
    border-radius: 15px;
  }
  .reject-reason {
    max-width: 120px;
  }
  //限制富文本图片大小
  .content {
    img {
      max-width: 200px!important;
    }
  }

  /deep/ .content-tr-expand {
    background-color: #F8F8F8;
    display: flex;
  }
  .inner-item {
    flex: 1;
    padding-left: 30px;
    font-size: 12px;
    .item {
      margin-bottom: 10px;
    }
    .label {
       color: #B7B8C9;
      padding-right: 20px;
    }
  }
}
</style>
<style lang="scss">
.msg-reply-rule {
  //限制富文本图片大小
  .content {
    img {
      max-width: 200px!important;
    }
  }
}
</style>
